<div class="wrapper wrapper-content">
  <div class="container-fluid">

    <div class="row">
      <h3>Financiación</h3>
      <div class="col-12 py-2 px-2">
        <p-table [value]="financeLines?.data" [responsive]="true">
          <ng-template pTemplate="header">
            <tr>
              <th *ngFor="let colHeader of financeColHeaders" class="text-center">{{ colHeader | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-financeLine let-rowIndex="rowIndex">
            <tr [ngClass]="(financeLine.organic) ? undefined : 'font-bold font-italic text-center'">
              <td class="text-center">{{financeLine.organic}}</td>
              <td class="text-center">{{financeLine.functional}}</td>
              <td class="text-center">{{financeLine.economical}}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr class="text-center">
              <td [attr.colspan]="financeColHeaders.length">{{ 'General.noData' | translate }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="row">
      <h3>Valor Estimado por lotes</h3>
      <div class="col-12 py-2 px-2">
        <p-table [value]="budgetLines.data" [responsive]="true">
          <ng-template pTemplate="header">
            <tr>
              <th *ngFor="let colHeader of budgetColHeaders" class="text-center">{{ colHeader | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-lot let-rowIndex="rowIndex">
            <tr [ngClass]="(lot.lotNumber) ? undefined : 'font-bold font-italic text-center'">
              <td class="text-center">{{ (lot.lotNumber) ?
                lot.lotNumber : 'Total'}}</td>
              <td>
                <formatDataValue [type]="'CURRENCY'" [value]="lot.budget?.estimatedAmount || 0">
                </formatDataValue>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr class="text-center">
              <td [attr.colspan]="budgetColHeaders.length">{{ 'General.noData' | translate }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
    <div class="row">
      <h3>Distribución de anualidades por lotes</h3>
      <div class="col-12 py-2 px-2">
        <p-table [value]="distributionLines" [responsive]="true">
          <ng-template pTemplate="header">
            <tr>
              <th *ngFor="let colHeader of distributionColHeaders" class="text-center">{{ colHeader | translate }}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-distributionLine let-rowIndex="rowIndex">
            <tr [ngClass]="(distributionLine.lot.lotNumber) ? undefined : 'font-bold font-italic text-center'">
              <td class="text-center">{{
                distributionLine.lot.lotNumber
                }}</td>
              <td class="text-center">{{distributionLine.accountLine?.year}}</td>
              <td class="text-center">{{distributionLine.accountLine?.organic}}</td>
              <td class="text-center">{{distributionLine.accountLine?.functional}}</td>
              <td class="text-center">{{distributionLine.accountLine?.economical}}</td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr class="text-center">
              <td [attr.colspan]="distributionColHeaders.length">{{ 'General.noData' | translate }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
</div>